import AOS from "aos";
import lozad from "lozad";
import { setBackgroundElement, detectCloseElement, buttonToTop, clickScrollToDiv, appendCaptchaASP, ToggleItem } from "./helper";
import { header } from "./header";
import swiperInit from "./swiper";
import { product } from "./product";
$(document).ready(function () {
	setBackgroundElement();
	header.init();
	product.init();
	swiperInit();
	buttonToTop();
	//
	storeSystem();
	ToggleItem();
	addInputAffliate();
	toolFixed();
	showMoreContent();
});
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
/*==================== Store System ====================*/
function storeSystem() {
	$("body").on("click", ".item-map", function () {
		const dataIframe = $(this).data("iframe");
		console.log("🚀 ~ dataIframe:", dataIframe);
		const nodeIframe = $("body").find(".iframe-map iframe");
		nodeIframe.attr("src", dataIframe);
		$(this).toggleClass("active").siblings().removeClass("active");
	});
}

/*==================== Add Inputs ====================*/
function addInputAffliate() {
	var index = 1;

	// Function to update textarea with facebook URLs
	function updateTextarea() {
		var facebookUrls = [];
		$('input[name^="facebookUrl-"]').each(function () {
			if ($(this).val().trim() !== "") {
				facebookUrls.push($(this).val().trim());
			}
		});
		$('textarea[name="facebook"]').val(facebookUrls.join("\n"));
	}

	// Add new input field on button click
	$(".btn-add").on("click", function (e) {
		e.preventDefault();
		index++;
		var newInput = `
				<div class="form-input form-primary">
					<input type="text" name="facebookUrl-${index}" placeholder="https://www.facebook.com/yourprofile${index}">
				</div>`;
		$(".wrap-inputs").append(newInput);
	});

	// Update textarea when input values change
	$(document).on("input", 'input[name^="facebookUrl-"]', function () {
		updateTextarea();
	});
}

/*==================== Home 4 Tab ====================*/
$(".section-home-4 .wrap-wrap-slide-tab .item-text").on("click", function () {
	const index = $(this).data("index");
	$(this).closest(".swiper-slide").addClass("active").siblings().removeClass("active");
	$(".section-home-4 .wrap-box-product")
		.eq(index)
		.addClass("active")
		.fadeIn(200, function () {
			$(this).css("opacity", "1");
		})
		.siblings(".wrap-box-product")
		.removeClass("active")
		.css("opacity", "0")
		.hide();
});

/*==================== Countdown time ====================*/
$(document).ready(function () {
	// Function to initialize the countdown
	function initializeCountdown() {
		$(".countdown-time").each(function () {
			const endDateAttr = $(this).data("date-end");
			if (!endDateAttr) return;
			const endDate = new Date(endDateAttr).getTime();
			const $element = $(this);

			// Function to update the countdown
			function updateCountdown() {
				const now = new Date().getTime();
				const timeRemaining = endDate - now;

				if (timeRemaining > 0) {
					const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
					const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
					const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
					$element.html(`
						<p>${days.toString().padStart(2, "0")}<span>Ngày</span></p>
                        <p>${hours.toString().padStart(2, "0")}<span>Giờ</span></p>
                        <p>${minutes.toString().padStart(2, "0")}<span>Phút</span></p>
                        <p>${seconds.toString().padStart(2, "0")}<span>Giây</span></p>
                    `);
				} else {
					$element.html(`
                        <p>0</p>
                        <p>00</p>
                        <p>00</p>
                        <p>00</p>
                    `);
				}
			}
			// Initial call to set the countdown immediately
			updateCountdown();
			// Update the countdown every second
			setInterval(updateCountdown, 1000);
		});
	}
	// Initialize the countdown
	initializeCountdown();
});

/*==================== Tool Fixed ====================*/
function toolFixed() {
	$(".tool-fixed").on("click", function () {
		$(this).toggleClass("active");
		if ($(this).hasClass("active")) {
			$(".button-to-top").removeClass("active");
		} else {
			$(".button-to-top").addClass("active");
		}
	});
}

/*==================== Show More Content ====================*/
function showMoreContent() {
	const $button = $(".btn-show-content");
	if (!$button.length) return;
	const heightContentInit = $(".wrap-show-content").outerHeight();
	const heightContentWrap = $(".wrap-show-content-wrap").outerHeight();
	const heightContentLimit = $(".wrap-show-content .wrap p").eq(0).outerHeight(true) + $(".wrap-show-content .wrap p").eq(1).outerHeight(true) + $(".wrap-show-content .wrap p").eq(2).outerHeight(true);
	$(".wrap-show-content").css("height", heightContentLimit);
	if (heightContentWrap > heightContentInit) {
		$button.show();
	}
	if (!$button.length) return;
	$button.on("click", function () {
		$(this).toggleClass("active");
		const isActive = $(this).hasClass("active");
		if (!isActive) {
			$(this).prev().css("height", "330px");
		} else {
			$(this).prev().css("height", "auto");
		}
		// Click change text
		const text = $(this).text();
		console.log("🚀 ~ text:", text);
		$(this).text(isActive ? "Rút gọn" : "Xem thêm");
	});
}
